module.exports = __webpack_public_path__ + "img/arrow-up.42b92dd2.svg";